export const PAY_FREQUENCY_ENUM = {
    "Weekly": 1,
    "Biweekly": 2,
    "Monthly": 3,
    "Quarterly": 4,
    "Semimonthly": 5,
    "Annually": 6
};

export const PROFIT_CENTER_OPTIONS = [
    { label: "Single", value: 1 },
    { label: "Multiple", value: 2 }
];

export const STATUS_OPERATOR_MAP = {
    "Completed": 8,
    "Failed": 9,
    "Attention Needed": 10,
    "Deleted": 11,
};

export const STATUS_VALUE_MAP = {
    "Completed": "1",
    "Failed": "4",
    "Attention Needed": "5",
    "Deleted": "3",
};

export const SEARCH_FIELD_OPTIONS = [
    { label: "Corporation", type: "corporation" },
    { label: "SortBy", type: "sort" },
    { label: "Wage Cost Name", columnType: 4, type: "text" },
    { label: "Account Number", columnType: 2, type: "text" },
    { label: "Total Payment", columnType: 3, type: "number" },
    { label: "Status", columnType: 1, type: "status" }
];

export const TEXT_CONDITIONS = ["Starts With", "Ends With", "Contains", "Equal"];
export const NUMERIC_CONDITIONS = ["None", ">=", "<=", "="];
export const STATUS_OPTIONS = ["--All--", "Completed", "Pending", "Resume", "Deleted"];

export const SORT_BY_OPTIONS = [
    { label: "Latest Entries", value: 101 },
    { label: "Latest Created", value: 102 },
    { label: "Latest Modified", value: 103 },
    { label: "Pay Period", value: 104 },
    { label: "Corporation Name", value: 105 },
    { label: "Total Payment", value: 106 },
    { label: "Account Number", value: 107 },
    { label: "Wage Cost Name", value: 108 },
];

export const TEXT_OPERATOR_MAP = {
    "Equal": 1,
    "Starts With": 2,
    "Ends With": 3,
    "Contains": 4,
};

export const NUMBER_OPERATOR_MAP = {
    "=": 1,
    ">=": 5,
    "<=": 6,
};

export const COLUMN_TYPE_TO_FIELD = {
    4: "Wage Cost Name",
    2: "Account Number",
    3: "Total Payment",
    1: "Status",
};

export const OPERATOR_TO_TEXT_CONDITION = {
    1: "Equal",
    2: "Starts With",
    3: "Ends With",
    4: "Contains",
};

export const OPERATOR_TO_NUMBER_CONDITION = {
    1: "=",
    5: ">=",
    6: "<=",
};

export const OPERATOR_TO_STATUS = {
    8: "Completed",
    10: "Attention Needed",
};

export const SALUTATIONS_ENUM = [
    { id: 1, label: "Mr." },
    { id: 2, label: "Ms." },
    { id: 3, label: "Mrs." },
    { id: 4, label: "Dr." },
    { id: 5, label: "Prof." },
    { id: 6, label: "Rev." },
];

export const GENDER_OPTIONS = [
    { id: 1, label: "Male" },
    { id: 2, label: "Female" },
    { id: 3, label: "Other" },
];


export const SETUP_FILTER_OPTIONS = [
    { label: 'Begins with', value: 'begins_with' },
    { label: 'Contains', value: 'contains' },
    { label: "Doesn't contain", value: 'not_contains' },
    { label: 'Ends with', value: 'ends_with' },
    { label: 'Equals', value: 'equals' },
    { label: "Doesn't equal", value: 'not_equals' },
];

export const FILTER_OPTION_MAP = {
    begins_with: 0,
    contains: 1,
    not_contains: 2,
    ends_with: 3,
    equals: 4,
    not_equals: 5
};


export const ITEM_TYPE_OPTIONS = [
    { label: "Wages", value: "wages", id: 8 },
    { label: "Additions", value: "additions", id: 9 },
    { label: "Deductions", value: "deductions", id: 10 },
    { label: "Employee Taxes", value: "employee_taxes", id: 11 },
    { label: "Employer Taxes", value: "employer_taxes", id: 12 },
];

export const ITEM_TYPE_MAP = {
    8: "Wages", 9: "Additions", 10: "Deductions",
    11: "Employee Taxes", 12: "Employer Taxes",
};

export const ITEM_TYPE = {
    Wages: 8,
    Additions: 9,
    Deductions: 10,
    EmployeeTaxes: 11,
    EmployerTaxes: 12,
    NetPay: 14
};

export const DATE_RANGE_MAP = {
    0: "Range",
    1: "Today",
    2: "Yesterday",
    // 12: "Recent", // Duplicate key in original code, 12 is used for Last Month - to - Date
    4: "Past 30 Days",
    5: "This Week",
    6: "This Week – to – Date",
    7: "Last Week",
    8: "Last Week–to–Date",
    22: "Next Week",
    24: "Next Four Weeks",
    9: "This Month",
    10: "This Month – to – Date",
    11: "Last Month",
    12: "Last Month – to – Date",
    23: "Next Month",
    13: "This Year",
    14: "This Year – to – Date",
    15: "Last Year",
    16: "Last Year – to – Date",
    26: "Next Year",
    17: "This Quarter",
    18: "This Quarter – to – Date",
    19: "Last Quarter",
    20: "Last Quarter – to – Date",
    25: "Next Quarter",
};


//---------------------------------
// Payroll Preference - Automation Type
//---------------------------------
export const AUTOMATION_TYPES = {
    API: "1",
    EMAIL: "2",
};


// =================================
// emplooyment Info
// ================================

export const MARITAL_STATUS_MAP = { "Single": 1, "Married": 2, "Divorced": 3, "Widowed": 4 };



//==================================
// Labour
//==================================

export const departments = [
    { id: 'all', name: 'All' },
    { id: 'engineering', name: 'Engineering' },
    { id: 'support', name: 'Support' },
    { id: 'operations', name: 'Operations' },
];

export const displayFields = [
    { id: 'punchIn', label: 'Punch In' },
    { id: 'punchOut', label: 'Punch Out' },
    { id: 'scheduledHrs', label: 'Scheduled Hrs' },
    { id: 'actualHrs', label: 'Actual Hours' },
    { id: 'overtimeHrs', label: 'Overtime Hrs' },
    { id: 'varianceHrs', label: 'Variance Hrs' },
    { id: 'varianceOvertimeHrs', label: 'Variance / OverTime Hrs' },
    { id: 'otPercent', label: 'OT %' },
    { id: 'otRisk', label: 'OT Risk' },
    { id: 'status', label: 'Status' },
];

export const jobTitles = [
    { id: 'all', name: 'All' },
    { id: 'developer', name: 'Developer' },
    { id: 'teamLead', name: 'Team Lead' },
    { id: 'manager', name: 'Manager' },
];

export const reportTypes = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
];

